import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-hrc-status',
  templateUrl: './hrc-status.component.html',
  styleUrls: ['./hrc-status.component.css']
})
export class HrcStatusComponent implements ICellRendererAngularComp {
  statusText = {
    Rejected: { text: 'Rejected', bgColor: '#FF3030', color: '#FFF' },
    Approved: { text: 'Approved', bgColor: '#228B22', color: '#FFF' },
    Verified: { text: 'Verified', bgColor: '#a8be37', color: '#FFF' },
    InReview: { text: 'In Review', bgColor: '#FFC300' },
    Overdue: { text: 'Overdue', bgColor: '#FF5733', color: '#FFF' },
    Pending: { text: 'Pending', bgColor: '#EF9460', color: '#FFF' },
    Submitted: { text: 'Submitted', bgColor: '#31EAE8' },
    Generated: { text: 'Generated', bgColor: '#c9c9c9' },
  };
  statusArray = Object.keys(this.statusText);

  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  getStatusPercentage(task, totalTasks) {
    return `${((task * 100) / totalTasks).toFixed(2)}%`;
  }

}
